export default __webpack_public_path__ + "static/media/banner_img2.02fd1ff2.png";